// @flow

import $ from 'jquery'

import Translation from '../i18n/Translation'
import OrderValidation from '../validation/OrderValidation'

export default class Contract {
  static async handleSubmit (event: Event) {
    event.preventDefault()

    const consumptionAmount = $('input[name="consumption_amount"]')
    const postalCode = $('input[name="postal_code"]')

    const consumptionAmountError = $('#consumption_amount_error_message')
    const postalCodeError = $('#postal_code_error_message')

    let hasError = false

    if (!consumptionAmount.val()) {
      consumptionAmountError.show()
      consumptionAmountError.text(Translation.getText('consumption_per_year'))
      consumptionAmount.addClass('has-error')

      hasError = true
    }
    else {
      consumptionAmountError.hide()
      consumptionAmount.removeClass('has-error')
    }

    if (!postalCode.val()) {
      postalCodeError.show()
      postalCodeError.text(Translation.getText('empty_input'))
      postalCode.addClass('has-error')

      hasError = true
    }
    else if (!await OrderValidation.isValidPostalCode(postalCode.val())) {
      postalCodeError.show()
      postalCodeError.text(Translation.getText('postal_code'))
      postalCode.addClass('has-error')

      hasError = true
    }
    else {
      postalCodeError.hide()
      postalCode.removeClass('has-error')
    }

    if (!hasError) {
      $('#calc_now').off('submit', Contract.handleSubmit)

      requestAnimationFrame(() => {
        $('#calc_now').submit()
      })
    }
  }

  static init () {
    const calcNow = document.getElementById('calc_now')

    const defaultStr = localStorage.getItem("url_defaults")
    let urlDefaults = null
    if (defaultStr) {
      urlDefaults = JSON.parse(defaultStr)
    }

    if (urlDefaults) {
      const postalCode = $('input[name="postal_code"]')
      const zip = urlDefaults["postal_code"] 
      if (zip) {
        postalCode.val(zip)
      }
    }

    let t = window.localStorage.getItem("vol_orders_customer_type")
    if (!t) {
      window.localStorage.setItem("vol_orders_customer_type","private")
    }
    t = window.localStorage.getItem("vol_dm_customer_type")
    if (!t) {
      window.localStorage.setItem("vol_dm_customer_type","private")
    }




    if (calcNow) {
      $(calcNow).on('submit', Contract.handleSubmit)
    }
  }
}
